<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">

      <b-form @submit.prevent="submitForm">
        <b-card-header class="border-0 pl-0">
          <h3 class="mb-0"> {{ $t('nuevo_egreso') }} </h3>
        </b-card-header>
        <b-row class="card-ing">
          <b-col md="12">
            <b-row>
              <!--b-col md="2" class="ai-c">
                <b-form-radio-group v-model="form.Tipo" name="tipo">
                  <b-form-radio value="O">{{ $t('origen') }}</b-form-radio>
                  <b-form-radio value="D">{{ $t('destino') }}</b-form-radio>
                </b-form-radio-group>
              </b-col-->

              <b-col md="2">
                <b-form-group label="Pais" label-for="paisID">
                  <template v-slot:label>
                    {{ $t('pais') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="paisID" @change="onChangePais" v-model="form.PaisID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in paisOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Fecha" label-for="fecha">
                  <template v-slot:label>
                    {{ $t('fecha') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="fecha" type="date" v-model="form.Fecha" ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="6">
            <b-row class="mb-2">
              <strong>1. {{ $t('origen') }}</strong>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group label="Empresa Origen" label-for="empresaID">
                  <template v-slot:label>
                    {{ $t('empresa') + ' ' + $t('origen') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="empresaID" :disabled="!isPaisSelected" v-model="form.EmpresaID"
                    @change="onEmpresaOrigenChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in empresaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Origen" label-for="plantaOrigenID">
                  <template v-slot:label>
                    {{ $t('planta') + ' ' + $t('origen') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="plantaOrigenID" :disabled="!isEmpresaSelected" v-model="form.PlantaOrigenID"
                    @change="onPlantaOrigenChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in plantaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Origen" label-for="pasilloOrigenID">
                  <template v-slot:label>
                    {{ $t('pasillo') + ' ' + $t('origen') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="pasilloOrigenID" :disabled="!isPlantaSelected" v-model="form.PasilloOrigenID"
                    >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in pasilloOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

            </b-row>
          </b-col>

          <b-col md="6">
            <b-row class="mb-2">
              <strong>2. {{ $t('transporte_origen') }}</strong>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group label="Chofer" label-for="choferID">
                  <template v-slot:label>
                    {{ $t('chofer') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="choferID" v-model="form.ChoferID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in choferOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label-for="patente">
                  <template v-slot:label>
                    {{ $t('patente_camion') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="patente" v-model="form.Patente" 
                    placeholder="Ingrese la patente"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label-for="patente">
                  <template v-slot:label>
                    {{ $t('patente_carro') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="patente" v-model="form.PatenteCarro" 
                    placeholder="Ingrese la patente"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="12">
            <b-row class="mb-2">
              <strong>3. {{ $t('destino') }}</strong>
            </b-row>
            <b-row>
              <b-col class="col-md-2">
                <b-form-group label="Empresa Destino" label-for="empresaDestinoID">
                  <template v-slot:label>
                    {{ $t('empresa') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="empresaDestinoID" :disabled="!isPaisSelected" v-model="form.EmpresaDestinoID"
                    @change="onEmpresaDestinoChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in empresaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col class="col-md-2">
                <b-form-group label="Destino" label-for="plantaDestintoID">
                  <template v-slot:label>
                    {{ $t('planta') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="plantaDestintoID" :disabled="!isEmpresaDestinoSelected"
                    v-model="form.PlantaDestinoID" @change="onPlantaDestinoChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in plantaDestinoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col class="col-md-2">
                <b-form-group label="Destino" label-for="pasilloDestintoID">
                  <template v-slot:label>
                    {{ $t('pasillo') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="pasilloDestintoID" :disabled="!isPlantaDestinoSelected"
                    v-model="form.PasilloDestinoID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in pasilloDestinoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

          </b-col>

          <b-col md="6">
            <b-row class="mb-2">
              <strong>4. {{ $t('guia_despacho') }}</strong>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="guiaTraslado">
                  <template v-slot:label>
                    {{ $t('guia_traslado') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="guiaTraslado" v-model="form.GuiaTraslado" 
                    :placeholder="$t('guia_traslado')"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md-4>
                <b-form-group label="Monto g_traslado" label-for="montoGuiaTraslado">
                  <template v-slot:label>
                    {{ $t('monto_guia_traslado') }}<span class="text-danger">*</span>
                  </template>
                  <b-form-input id="montoGuiaTraslado" v-model="form.MontoGuiaTraslado" type="text" @keypress="onlyNumbers"
                     :placeholder="$t('monto')"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label="$t('peso_neto')" label-for="peso">
                  <template v-slot:label>
                    {{ $t('peso_neto') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="peso"
                    v-model="form.Peso"
                    type="text"
                    @keypress="onlyNumbersCL"
                    @input="onInputCL('Peso', $event)"
                    :placeholder="$t('peso_neto')">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="6">
            <b-row class="mb-2">
              <strong>5. {{ $t('materiales') }}</strong>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label="Material Recibido" label-for="materialID">
                  <template v-slot:label>
                    {{ $t('material_despachado') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="materialID" v-model="form.MaterialID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in materialOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label="Uom" label-for="uomID">
                  <template v-slot:label>
                    {{ $t('uom') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="uomID" v-model="form.UomID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in uomOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="8">
            <b-row class="mb-2">
              <strong>6. {{ $t('valor') }}</strong>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label="Precio" label-for="precio">
                  <template v-slot:label>
                    {{ $t('precio') }}<span class="text-danger">*</span>
                  </template>
                  <b-form-input id="precio" :value="$utilsService.getFormattedValue('Precio', form)" @keypress="onlyNumbers"
                  @input="$utilsService.onInput('Precio', form, $event)" type="text" 
                    :placeholder="$t('precio')"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label="Moneda" label-for="monedaID">
                  <template v-slot:label>
                    {{ $t('moneda') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="monedaID" v-model="form.MonedaID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in monedaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="porcentaje">
                  <template v-slot:label>
                    {{ $t('porcentaje_producto') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="porcentaje" v-model="form.PorcentajeProducto" 
                    placeholder="Ingrese la porcentaje"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group :label="$t('comentarios')" label-for="comentariosDescuento">
                  <b-form-textarea id="comentariosDescuento" v-model="form.ComentariosDescuento"
                    :placeholder="$t('comentarios')"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-button variant="danger" class="ml-2" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i> {{ $t('cancelar') }}
        </b-button>
        <b-button type="submit" variant="primary">
          {{ $t('guardar') }}
        </b-button>
      </b-form>
    </base-header>
  </div>
</template>
<script>
import egresoService from '@/api/egresoService';
import miscService from '@/api/miscService';
import { Select, Option } from 'element-ui'
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      form: {
        Patente: '',
        ChoferID: null,
        EmpresaID: null,
        EmpresaDestinoID: null,
        Fecha: '',
        MaterialID: null,
        GuiaTraslado: '',
        MontoGuiaTraslado: '',
        Peso: '',
        TicketInex: '',
        Descuento: '',
        Comentarios: '',
        Precio: '',
        PesoTotal: '',
        MonedaID: null,
        UomID: null,
        PasilloOrigenID: null,
        PasilloDestinoID: null,
        PlantaOrigenID: null,
        PlantaDestinoID: null,
        PaisID: null,
      },
      materialOptions: [],
      conformidadOptions: [],
      uomOptions: [],
      monedaOptions: [],
      empresaOptions: [],
      choferOptions: [],
      paisOptions: [],
      plantaOptions: [],
      plantaDestinoOptions: [],
      pasilloOptions: [],
      pasilloDestinoOptions: [],
      isEmpresaSelected: false,
      isEmpresaDestinoSelected: false,
      isPlantaSelected: false,
      isPlantaDestinoSelected: false,
      isPaisSelected: false
    };
  },
  async beforeMount() {
    const [
      choferOptions,
      empresaOptions,
      materialOptions,
      conformidadOptions,
      monedaOptions,
      uomOptions,
      paisOptions
    ] = await Promise.all([
      miscService.getChoferesOptions(),
      miscService.getEmpresasOptions(),
      miscService.getMaterialesOptions(),
      miscService.getConformidadesOptions(),
      miscService.getMonedasOptions(),
      miscService.getUomsOptions(),
      miscService.getPaisesOptions(),
    ]);

    this.choferOptions = choferOptions;
    this.empresaOptions = empresaOptions;
    this.materialOptions = materialOptions;
    this.conformidadOptions = conformidadOptions;
    this.monedaOptions = monedaOptions;
    this.uomOptions = uomOptions;
    this.paisOptions = paisOptions;
  },  
  methods: {
    onlyNumbersCL(event) {
  const ctrl = ['Backspace','Delete','Tab','Enter','ArrowLeft','ArrowRight','Home','End'];
  if (ctrl.includes(event.key)) return;

  // Solo dígitos y coma (el punto de miles lo pondremos nosotros automáticamente)
  if (!/[0-9,]/.test(event.key)) {
    event.preventDefault();
    return;
  }

  // Permitir solo UNA coma en todo el valor
  const v = event.target.value || '';
  if (event.key === ',' && v.includes(',')) {
    event.preventDefault();
  }
},

// Formatea con miles usando punto y decimales con coma
formatCLChilean(text) {
  if (!text) return '';
  // Mantener solo dígitos y comas; dejar una sola coma (la primera)
  let t = String(text).replace(/[^0-9,]/g, '');
  const firstComma = t.indexOf(',');
  if (firstComma !== -1) {
    const left = t.slice(0, firstComma + 1);
    const right = t.slice(firstComma + 1).replace(/,/g, ''); // quita comas extra
    t = left + right;
  }

  // Separar parte entera y decimal
  let entero = t, decimal = '';
  if (firstComma !== -1) {
    const parts = t.split(',');
    entero = parts[0];
    decimal = parts[1] || '';
  }

  // Quitar ceros a la izquierda (dejar 0 si queda vacío)
  entero = entero.replace(/^0+(?=\d)/, '');
  if (entero === '') entero = '0';

  // Aplicar separador de miles con punto
  entero = entero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return decimal !== '' ? `${entero},${decimal}` : entero;
},

// Usado por @input para formatear en vivo
onInputCL(field, e) {
  const el = e && e.target ? e.target : null;
  const val = el ? el.value : this.form[field];
  const formatted = this.formatCLChilean(val);
  this.form[field] = formatted;
  if (el) {
    el.value = formatted;
    // Mantener el cursor al final (simple y suficiente)
    this.$nextTick(() => {
      const pos = formatted.length;
      try { el.setSelectionRange(pos, pos); } catch(_) {}
    });
  }
},

// Normaliza a punto para enviar al backend (quita miles)
sanitizeDecimalForApi(v) {
  if (v === '' || v == null) return null;
  let t = String(v).trim();
  if (t.includes(',')) {
    t = t.replace(/\./g, ''); // quita separadores de miles
    t = t.replace(/,/g, '.'); // coma -> punto
  } else {
    // Si no hay coma pero hay puntos, dejar solo el primero como decimal
    const i = t.indexOf('.');
    if (i !== -1) {
      const left = t.slice(0, i + 1);
      const right = t.slice(i + 1).replace(/\./g, '');
      t = left + right;
    }
  }
  t = t.replace(/[^0-9.]/g, '');
  return t;
},
    async onEmpresaOrigenChange() {
      const empresa = this.form.EmpresaID;
      this.form.PasilloOrigenID = null;
      this.form.PlantaOrigenID = null;
      if (empresa) {
        this.plantaOptions = await miscService.getPlantasByEmpresaOptions(empresa);
        this.isEmpresaSelected = true;
      } else {
        this.plantaOptions = [];
        this.isEmpresaSelected = false;
      }
    },
    async onEmpresaDestinoChange() {
      const empresa = this.form.EmpresaDestinoID;
      this.form.PasilloDestinoID = null;
      this.form.PlantaDestinoID = null;
      if (empresa) {
        this.plantaDestinoOptions = await miscService.getPlantasByEmpresaOptions(empresa);
        this.isEmpresaDestinoSelected = true;
      } else {
        this.plantaOptions = [];
        this.isEmpresaDestinoSelected = false;
      }
    },
    async onPlantaOrigenChange() {
      const empresa = this.form.EmpresaID;
      const planta = this.form.PlantaOrigenID;
      if (empresa && planta) {
        this.pasilloOptions = await miscService.getPasillosByEmpresaOptions(empresa, planta);
        this.isPlantaSelected = true;
      } else {
        this.pasilloOptions = [];
        this.isPlantaSelected = false;
      }
    },
    async onPlantaDestinoChange() {
      const empresa = this.form.EmpresaDestinoID;
      const planta = this.form.PlantaDestinoID;
      if (empresa && planta) {
        this.pasilloDestinoOptions = await miscService.getPasillosByEmpresaOptions(empresa, planta);
        this.isPlantaDestinoSelected = true;
      } else {
        this.pasilloDestinoOptions = [];
        this.isPlantaDestinoSelected = false;
      }
    },
    async onChangePais() {
      this.form.PasilloDestinoID = null;
      this.form.PlantaDestinoID = null;
      this.form.PasilloOrigenID = null;
      this.form.PlantaOrigenID = null;
      this.form.EmpresaID = null;
      this.form.EmpresaDestinoID = null;
      this.isEmpresaDestinoSelected = false;
      this.isPlantaSelected = false;
      this.isPlantaDestinoSelected = false;
      this.isEmpresaSelected = false;
      this.empresaOptions = await miscService.getEmpresasByPaisOptions(this.form.PaisID);
      this.isPaisSelected = true;
    },
    validateRequiredFields() {
      const requiredFields = [
        { field: 'PaisID', name: 'País' },
        { field: 'Fecha', name: 'Fecha' },
        { field: 'EmpresaID', name: 'Empresa Origen' },
        { field: 'PlantaOrigenID', name: 'Planta Origen' },
        { field: 'PasilloOrigenID', name: 'Pasillo Origen' },
        { field: 'ChoferID', name: 'Chofer' },
        { field: 'Patente', name: 'Patente Camión' },
        { field: 'PatenteCarro', name: 'Patente Carro' },
        { field: 'EmpresaDestinoID', name: 'Empresa Destino' },
        { field: 'PlantaDestinoID', name: 'Planta Destino' },
        { field: 'PasilloDestinoID', name: 'Pasillo Destino' },
        { field: 'GuiaTraslado', name: 'Guía de Traslado' },
        { field: 'MontoGuiaTraslado', name: 'Monto Guía Traslado' },
        { field: 'Peso', name: 'Peso Neto' },
        { field: 'MaterialID', name: 'Material Despachado' },
        { field: 'UomID', name: 'UOM' },
        { field: 'Precio', name: 'Precio' },
        { field: 'MonedaID', name: 'Moneda' },
        { field: 'PorcentajeProducto', name: 'Porcentaje Producto' }
      ];

      const missingFields = [];

      requiredFields.forEach(({ field, name }) => {
        const value = this.form[field];
        if (value === null || value === undefined || value === '') {
          missingFields.push(name);
        }
      });

      return missingFields;
    },
    async submitForm() {
      // Validar campos requeridos
      const missingFields = this.validateRequiredFields();
      
      if (missingFields.length > 0) {
        const fieldsList = missingFields.join(', ');
        Swal.fire({
          icon: "warning",
          title: "Campos requeridos",
          html: `Los siguientes campos son requeridos:<br><strong>${fieldsList}</strong>`,
          confirmButtonText: "Entendido"
        });
        return;
      }

      Swal.fire({
        title: this.$t('guardar'),
        text: this.$t('estas_seguro_guardar'),
        icon: 'info',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('aceptar'),
        denyButtonText: this.$t('cancelar'),
      }).then(async (result) => {
  if (result.isConfirmed) {
    try {
      // 🔽 Arma el payload normalizando solo lo necesario para la API
      const payload = {
        ...this.form,
        Peso: this.sanitizeDecimalForApi(this.form.Peso),
        MontoGuiaTraslado: this.sanitizeDecimalForApi(this.form.MontoGuiaTraslado),
        Precio: this.sanitizeDecimalForApi(this.form.Precio),
      };

      const response = await egresoService.create(payload);
      if (!response) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Ocurrió un error al crear el egreso, intente nuevamente.'
        });
        return;
      }

      Swal.fire({
        title: "Creado correctamente",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        background: '#f8f9fa',
        customClass: {
          title: 'swal-title',
          icon: 'swal-icon',
        },
      });
      this.$router.push(`/egresos/details/${response.egresoID}`);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message
      });
    }
  } else if (result.isDenied) {
    Swal.close();
  }
});
    },
    onlyNumbers(event) {
      // Solo permite números (0-9)
      if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete') {
        event.preventDefault();
      }
    }
  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}

.row.card-ing {
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.375rem;
  padding: 30px 0px;
  margin-bottom: 20px;
}
</style>
